import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// Copied from https://reactrouter.com/web/example/query-parameters
export const useQueryParams = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
};
